import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { GET_PLC_POPUP_STATUS } from "./actionTypes";
import { getPlcPopupStatusSuccess, getPlcPopupStatusError } from "./actions";

// Include call API
import { getSystemAPI } from "../../../api/system";

const systemAPI = getSystemAPI();

function* getPlcPopupStatusFetch(action) {
  try {
    const response = yield call(systemAPI.getPlcPopupStatus, action.payload?.token);
    let plc_popup_status = response.plc_popup_status;
    yield put(getPlcPopupStatusSuccess("Get plc status ok", plc_popup_status));
  } catch (error) {
    yield put(getPlcPopupStatusError(error));
  }
}

export function* watchGetPlcPopupStatus() {
  yield takeEvery(GET_PLC_POPUP_STATUS, getPlcPopupStatusFetch);
}

function* getPlcPopupStatusSaga() {
  yield all([fork(watchGetPlcPopupStatus)]);
}

export default getPlcPopupStatusSaga;
